import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { TournamentsService } from './../tournaments/services/tournaments.service';

declare let $;

declare let JsBarcode: any;

declare let SetLanguage: any;
@Component({
    selector: 'comp_print_slip',
    templateUrl: './print_slip.html',
})
export class PrintSlip implements OnInit {
    public init: boolean;

    constructor(public tournamentsService: TournamentsService) {
        SetLanguage('', '');
    }
    public ngOnInit() {
        SetLanguage('', '');
        if (this.init) {
            return;
        }
        this.init = true;
    }
}
